// extracted by mini-css-extract-plugin
export default {"modal":"BookingCancelModal_modal__rocHT","modalContent":"BookingCancelModal_modalContent__K4Het","modalActions":"BookingCancelModal_modalActions__RHG7p"};